import React from 'react';
import { SelectItem } from '@components/controlled-input-select/src/controlled-input-select.type';
import { AddGuestBody } from '@components/modals/add-holder-modal/src/add-holder-modal.type';
import { Addon } from '@domain/addon';
import { Admission } from '@domain/admission';
import { Channel } from '@domain/channel';
import { Event } from '@domain/event';
import { Pass } from '@domain/passes';
import { AddGuestResponse } from '@hooks/use-add-guest/use-add-guest';

import { ProcessStepContent } from './components/process-step-content';
import { OfflineSalesForm, OfflineSalesScope, ProcessOfflineSalesStep, SaleType } from './process-offline-sales.type';

export interface OfflineSalesStepsProps {
  step: ProcessOfflineSalesStep;
  setStep: (step: ProcessOfflineSalesStep) => void;
  offer?: Admission;
  event?: Event;
  saleType: SaleType;
  quantity: number;
  addGuestData?: AddGuestResponse;
  availableAddons: Addon[];
  selectedAddonIds?: string[];
  email?: string;
  isSubmitting?: boolean;
  closeModal: () => void;
  handleCloseModal: () => void;
  onSubmit: (data: OfflineSalesForm) => void;
  scope: OfflineSalesScope;
  selectedPass?: Pass;
  passModalChannels: Channel[];
  isLoadingPassChannels: boolean;
  defaultPassChannelId?: string;
  venueIsoCode: string;
  onPassHolderSubmit: (formValue: AddGuestBody) => void;
  preserveAddHolderModal: boolean;
  onPreserveAddHolderModalChange: (value: boolean) => void;
  closeWizardModal: () => void;
  passHolderMode: 'bulk' | 'single';
  onSelectSinglePassHolder: (passId?: string) => void;
  passOptions: SelectItem[];
  entryStep: ProcessOfflineSalesStep;
}

/*
 * OfflineSalesSteps Component
 *
 * Pure component that renders the specific steps for the Offline Sales process.
 * Receives all data and handlers as props from the parent ProcessOfflineSales component.
 */
export const OfflineSalesSteps: React.FC<OfflineSalesStepsProps> = (props) => {
  return <ProcessStepContent {...props} />;
};
